import React, { useState, useEffect } from 'react'
import { _isloadinginitial } from '../RecoilState';
import { useRecoilState } from 'recoil';
import { ArrowRightOutlined } from '@ant-design/icons';
import Loader from '../components/Loader';
import { Link } from 'react-router-dom'
import './components.css';

const Header = () => {
    const [isloading, setisLoading] = useRecoilState(_isloadinginitial)
    // const [loading, setLoading] = useState(true)

    const buyNow = () => {
        const link = 'https://www.yancha.in/survey-signup'
        console.log(link)
        // navigate(link)
        window.location.href = link;
        // setLoading(true);
    }

    return (
        <>
            <div className='header'>
                <div className='flex flex-row gap-4'>
                    <div className='w-1/3'>
                        {/* <div className='header-slideshow'>
                            <img src={require('../assets/yancha_logo.png')} width={75} alt="yancha teens" className='header-image' />
                            <img src={require('../assets/tanchateens_logo.png')} width={75} alt="yancha teens" className='header-image' />
                        </div> */}
                        <img src={require('../assets/yancha_pkt_logo.png')} width={75} alt="yancha" />

                    </div>

                    <div className='w-2/3 flex justify-end h-full items-center gap-5'>

                        {/* story of life */}
                        <Link to="/story-of-life">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/storyoflifelogo.png')} width={50} alt="programs" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>Story Of Life</p>
                            </div>
                        </Link>

                        {/* career */}
                        <Link to="/career-quiz">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/goal.png')} width={50} alt="home" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>Career</p>
                            </div>
                        </Link>

                        <Link to="/survey">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/survey.png')} width={50} alt="home" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>Surveys</p>
                            </div>
                        </Link>

                        <Link to="/nudges">
                            <div className='flex flex-col items-center'>
                                <img src={require('../assets/bell.png')} width={50} alt="notices" />
                                <p className='brand-font txt-xsmall text-center txt-bold'>Alerts</p>
                            </div>
                        </Link>
                        {/* </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header